<template>
	<div class="topSubMenuList">
		<div class="topSubMenuInnerWrap" ref="innerWrap">
			<template v-for="(menu, idx) in menu">
				<router-link class="subMenuLinkItem" :key="idx" :to="menu.link">{{menu.txt}}</router-link>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TopSubMenuList',
	components: {},
	data () {
		return {}
	},
	props: {
		menu: {
			type: Array,
			default: function () {
				return [
					{ link: '/', target: '', txt: '' }
				]
			}
		}
	},
	mounted () {
		console.log('this.$refs.innerWrap.scrollLeft:', this.$refs.innerWrap.scrollLeft)
		let activeBtn = document.querySelector('.topSubMenuInnerWrap .router-link-active')
		let activeLeft = activeBtn.offsetLeft

		if (window.innerWidth < (activeLeft + activeBtn.clientWidth)) {
			this.$refs.innerWrap.scrollLeft = activeLeft
		}
	},
	methods: {}
}
</script>

<style lang="scss">
@import '@/css/variables.scss';
/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
	//css
}
/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
}
</style>

<style lang="scss" scoped>
@import '@/css/variables.scss';

.topSubMenuList {
	$navH: 88px;
	position: relative;
	background-color: $c-blue-dark;
	text-align: center;
	/* margin-top: $navH; */
	z-index: 3;
	.topSubMenuInnerWrap {
		padding: 20px 0;
		.subMenuLinkItem {
			margin-right: 24px;
			color: rgba($c-white, 0.8);
			&.router-link-exact-active {
				font-weight: bold;
				color: rgba($c-white, 1);
				border-bottom: 1px solid rgba($c-white, 0.6);
			}
			&:last-child {
				margin-right: 0;
			}
		}
	}
}

/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	//CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
	//CSS
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
	.topSubMenuList {
		z-index: 3;
		padding: 0 10px;
		.topSubMenuInnerWrap {
			padding: 6px 20px;
			display: flex;
			flex-wrap: nowrap;
			overflow-x: auto;
			-webkit-overflow-scrolling: touch;
			scroll-snap-type: x mandatory;
			.subMenuLinkItem {
				font-size: 14px;
				margin-right: 8px;
				word-break: keep-all;
				flex: 0 0 29%;
				scroll-snap-align: start;
				letter-spacing: $lspace-short;
				white-space:nowrap;
			}
		}
	}
}
</style>
